// TODO: Fix eslint errors.
/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable func-names */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-empty */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import React, { useEffect, useState } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
// import { hot } from 'react-hot-loader/root';
import { IntlProvider } from 'react-intl';
import { TrackingProvider } from 'trackingContext';
import { AppProvider } from 'appContext';
import updateSecondLevelMenuActiveLink from 'updateSecondLevelMenuActiveLink';
import getOpCoRoutes from 'getOpCoRoutes';
import Logger from '@ffw/logger-lib';
import { Navigation, initEventsRel } from '@rel/experience';

// Import Pages
import Homepage from '@Pages/Homepage';
import SalaryChecker from '@Pages/SalaryChecker';
import NotFound from '@Pages/NotFound';

// We have to collect all routes outside the App function, because of the pageLoader.
// If we use the pageLoader inside a function, SSR won't load the components.
const routeComponents = [];
const routes = getOpCoRoutes();

// Iterate through all supported languages for the country.
for (const lang in routes) {
  // Iterate through all supported routes and components for the country.
  for (const routeName in routes[lang]) {
    const route = routes[lang][routeName];

    let Component = null;

    switch (route.component) {
      case 'SalaryChecker':
        Component = SalaryChecker;
        break;
      case 'homepage':
        Component = Homepage;
        break;
      default:
        break;
    }

    // Add the route in the renderable array.
    routeComponents.push(
      <Route key={routeName} path={`${route.url}`} component={Component} />,
    );
  }
}

// Everything that is not defined as route will lead to NotFound page.
routeComponents.push(<Route key="not-found" component={NotFound} />);

function App({ currentLanguage, context,  links, isEnableRelNavigation }) {
  // Get the language.
  const lang = currentLanguage || process.env.REACT_APP_DEFAULT_LANGUAGE;
  const isMyRandstadEnabled = process.env.REACT_APP_MYRANDSTAD_ENABLED === 'true';
  const isSavedJobIconEnabled = process.env.REACT_APP_ENABLE_SAVED_JOB_ICON === 'true';
  // Get the translations based on the language.
  let messages;

  try {
    messages = require(`../i18n/${process.env.REACT_APP_COUNTRY}/${lang}.json`);
  } catch (e) {
    // Use the translations from the default language if the file is missing.
    Logger.error(`Missing translation for: ${lang}`, 'App.js');
  }

  const navigationProps = {
    ...isMyRandstadEnabled && {
      myRandstad: {
        text: 'my randstad',
        href: '',
        user: null,
      },
    },
    ...isSavedJobIconEnabled && {
      savedJobs: {
        text: '0',
        href: '/',
      },
    },
    logo: {
      title: messages['MegaMenu.Logo.Title'],
      href: '/',
    },
    aria: {
      navigation: {
        menu: messages['MegaMenu.Aria.Navigation.Menu'],
        navigation: messages['MegaMenu.Aria.Navigation.Navigation'],
        close: messages['MegaMenu.Aria.Navigation.Close'],
      },
      megaMenu: {
        main: messages['MegaMenu.Aria.MegaMenu.Main'],
        close: messages['MegaMenu.Aria.MegaMenu.Close'],
      },
    },
  };

  const [myRandstadProps, setMyRandstadProps] = useState(navigationProps.myRandstad);
  const [savedJobsProps, setSavedJobsProps] = useState(navigationProps.savedJobs);

  useEffect(() => {
    document.querySelector('html').classList.add('js');
  }, []);

  useEffect(() => {
    if (isMyRandstadEnabled) {
      setMyRandstadProps({
        text: window.myRandstadText,
        href: window.myRandstadUrl,
        user: window.myRandstadUsername ? {
          initials: window.myRandstadUsername?.charAt(0)?.toUpperCase(),
          names: window.myRandstadUsername,
        } : null,
      });
    }

    const updateSavedJobsCounter = () => setSavedJobsProps({
      text: window.relNavFavoritesCounter,
      href: window.relNavFavoritesUrl,
    });

    if (isSavedJobIconEnabled) {
      updateSavedJobsCounter();
      document.addEventListener('favoritesCounterUpdated', () => {
        updateSavedJobsCounter()
      });
    }

    return () => {
      if (isSavedJobIconEnabled) {
        document.removeEventListener('favoritesCounterUpdated', updateSavedJobsCounter);
      }
    };
  }, []);

  /**
   * Implement datalayer events from REL for the Mega menu.
   */
  useEffect(() => {
    if (isEnableRelNavigation) {
      initEventsRel();
    }
  }, []);

  useEffect(() => {
    updateSecondLevelMenuActiveLink();
  }, [useLocation()]);

  return (
    <IntlProvider
      defaultLocale={process.env.REACT_APP_DEFAULT_LANGUAGE}
      locale={lang}
      messages={messages}
    >
      <TrackingProvider context={context}>
        <AppProvider context={context}>
          {isEnableRelNavigation && (
          <Navigation
            {...navigationProps}
            myRandstad={myRandstadProps}
            savedJobs={savedJobsProps}
            {...links}
          />
        )}
          <Switch>
            {routeComponents}
          </Switch>
        </AppProvider>
      </TrackingProvider>
    </IntlProvider>
  );
}

export default App;
